const textStyles = {
  h1: {
    fontSize: ["4xl", null, "5xl"],
    fontWeight: "light",
    textTransform: "uppercase",
    lineHeight: "shorter",
    // hyphens: "auto",
  },
  h2: {
    fontSize: ["2xl", null, "3xl"],
    fontWeight: "normal",
    lineHeight: "shorter",
  },
  h3: {
    fontSize: ["lg", null, "xl"],
    fontWeight: "normal",
    lineHeight: "shorter",
  },
  h4: {
    fontSize: ["3xs", null, "2xs", "xs"],
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  h5: {
    fontSize: ["3xs", null, "2xs", "xs"],
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  "paragraph-lg": {
    fontSize: ["lg", null, "2lg", "xl"],
  },
  paragraph: {
    fontSize: ["2sm", null, "sm", "md"],
  },
  "paragraph-sm": {
    fontSize: ["3xs", null, "2xs", "xs"],
  },
}

export default textStyles
